import * as SeparatorPrimitive from '@radix-ui/react-separator';

type SeparatorType = {
  className?: string;
};

const Separator = ({ className }: SeparatorType) => (
  <SeparatorPrimitive.Root
    decorative
    className={className}
  />
);

export { Separator };
